export default function formatName (name: string): string {
  return name.replace(/weapons\..*\./, '')
}
